import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import withExtensionContextProvider from '../hoc/withExtensionContextProvider';

const BasicLayout = ({ children }) => (
  <div className="c-notifications c-notifications-basic-layout">
    <Helmet>
      <meta name="viewport" content="width=670, initial-scale=1, maximum-scale=1" />
    </Helmet>
    {children}
  </div>
);


BasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withExtensionContextProvider(BasicLayout);



// WEBPACK FOOTER //
// ./src/app/notifications/layouts/BasicLayout.jsx